export type ValueOf<T> = T[keyof T];

export const RangeCardinality = Object.freeze({
  MAX: 'max',
  MIN: 'min'
});

export type RangeCardinalityValues = ValueOf<typeof RangeCardinality>;
export type RangeCardinalityKeys = keyof typeof RangeCardinality;